module.exports = __webpack_public_path__ + "static/media/login.e8160291.png";